import React from 'react'
import tacos from 'assets/img/tacos.jpg'
import ImageSection from '../ImageSection'

export default function MakeEveryoneHappy({ className, ...props }) {
  return (
    <ImageSection
      imageUrl={tacos}
      className={['md:text-white', className]}
      heading="Make Everyone Happy"
      description={`
        Choose from thousands of cuisine options and let guests customize
        individual orders during your event. No matter the dietary requirements,
        every tastebud will be satisfied.
      `}
      {...props}
    />
  )
}
